import React from 'react';
import img000 from '../components/images/sample.png';
import img2047 from '../components/images/rgamazon.png';

const Events = () => {
    return (
        <>
            <div className="row m-2">
                <img className="img-fluid" src={img2047} alt="amazon global" />
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <h2>Why Register for Amazon Global?</h2>
                        <p>
                            <strong>Amazon Global registration</strong> opens up opportunities to sell your products internationally, increasing your market reach and sales potential.
                        </p>
                    </div>
                    <div className="col-12 col-md-6">
                        <img className="img-fluid" src={img000} alt="Queryimg" />
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12 col-md-6">
                        <h2>Essential Details Required:</h2>
                        <ul className="list-group">
                            <li className="list-group-item"><strong>Email ID:</strong> For account setup and communication.</li>
                            <li className="list-group-item"><strong>Contact Number:</strong> Necessary for verification and customer support.</li>
                            <li className="list-group-item"><strong>Pickup Address:</strong> Important for product pickups and cross-border shipping.</li>
                            <li className="list-group-item"><strong>Bank Details:</strong> Required to receive payments securely from global sales.</li>
                            <li className="list-group-item"><strong>Product Category:</strong> Helps Amazon categorize your products for better visibility.</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-6">
                        <img className="img-fluid" src={img000} alt="Queryimg" />
                    </div>
                </div>

                <p className="mt-4">
                    <strong>Expand your business worldwide</strong> with Amazon Global. Contact E Seller Support for expert guidance.
                </p>
            </div>
        </>
    );
};

export default Events;
